
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const EventsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const upcomingEvents = [
    {
      id: 1,
      title: 'All Believers International Convention (ABIC) 2025',
      date: 'November 17 - 22, 2025',
      time: '9:00 AM - 6:00 PM Daily',
      location: 'Sagamu, Nigeria',
      category: 'convention',
      description: 'Join thousands of believers from around the world for four days of apostolic teaching, worship, and fellowship.',
      image: 'https://readdy.ai/api/search-image?query=large%20christian%20convention%20with%20thousands%20of%20people%20worshipping%20in%20modern%20auditorium%2C%20apostolic%20gathering%2C%20international%20conference%2C%20diverse%20crowd%20praising%20God%2C%20professional%20lighting%2C%20inspiring%20atmosphere&width=600&height=400&seq=abic2025&orientation=landscape',
      featured: true,
      registrationLink: ''
    },
    {
      id: 2,
      title: 'Quarterly Night of Grace',
      date: 'January 20-22, 2025',
      time: '6:00 PM - 9:00 PM',
      location: 'Accra, Ghana',
      category: 'prayer',
      description: 'A special quarterly vigil dedicated to prayer, miracles, and divine encounters',
      image: 'https://readdy.ai/api/search-image?query=outdoor%20evangelistic%20crusade%20in%20Africa%2C%20large%20crowd%20gathered%20for%20gospel%20preaching%2C%20evening%20service%20with%20stage%20lighting%2C%20people%20raising%20hands%20in%20worship%2C%20powerful%20ministry%20atmosphere&width=600&height=400&seq=ghana2025&orientation=landscape',
      featured: false,
      registrationLink: ''
    },
    {
      id: 3,
      title: 'Christ Family Network Fellowship',
      date: 'February 10-12, 2025',
      time: '10:00 AM - 4:00 PM',
      location: 'Virtual & Physical Centers',
      category: 'fellowship',
      description: 'A bi-weekly community gathering for connection, study, and brotherly support',
      image: 'https://readdy.ai/api/search-image?query=christian%20leadership%20conference%20with%20diverse%20group%20of%20ministers%20and%20leaders%20in%20modern%20conference%20room%2C%20apostolic%20training%20session%2C%20professional%20ministry%20setting%2C%20interactive%20learning%20environment&width=600&height=400&seq=cfnsummit&orientation=landscape',
      featured: false,
      registrationLink: ''
    },
    {
      id: 4,
      title: 'Ecclesia Weekly Services',
      date: 'March 5, 2025',
      time: '2:00 PM - 6:00 PM',
      location: 'Hyde Park, London, UK',
      category: 'service',
      description: 'The main congregational gatherings held every Sunday and Wednesday. Experience powerful worship, dynamic preaching, and community fellowship.',
      image: 'https://readdy.ai/api/search-image?query=outdoor%20christian%20rally%20in%20London%20park%20with%20diverse%20crowd%2C%20street%20evangelism%20event%2C%20worship%20and%20preaching%20in%20public%20space%2C%20urban%20ministry%20setting%2C%20people%20gathering%20for%20gospel&width=600&height=400&seq=londonrally&orientation=landscape',
      featured: false,
      registrationLink: ''
    },
    {
      id: 5,
      title: 'Altar of Worship and Intercession',
      date: 'April 15-20, 2025',
      time: 'All Day',
      location: 'Kaduna State, Nigeria',
      category: 'worship',
      description: 'A dedicated session focused on deep praise, worship, and intercession.',
      image: 'https://readdy.ai/api/search-image?query=medical%20mission%20in%20rural%20African%20village%2C%20healthcare%20workers%20serving%20community%2C%20gospel%20outreach%20in%20remote%20area%2C%20compassionate%20ministry%2C%20people%20receiving%20medical%20care%20and%20hearing%20gospel&width=600&height=400&seq=ruralmission&orientation=landscape',
      featured: false,
      registrationLink: ''
    },
    {
      id: 6,
      title: 'School of Ministry Training Sessions',
      date: 'May 1-3, 2025',
      time: '6:00 AM - 12:00 PM',
      location: 'Global (Online)',
      category: 'training',
      description: 'A structured training program designed to equip believers for ministerial work.',
      image: 'https://readdy.ai/api/search-image?query=global%20online%20prayer%20meeting%20with%20people%20from%20different%20nations%20praying%20together%20via%20video%20conference%2C%20international%20christian%20unity%2C%20diverse%20believers%20in%20worship%2C%20spiritual%20gathering&width=600&height=400&seq=prayersummit&orientation=landscape',
      featured: false,
      registrationLink: ''
    },
    {
      id: 7,
      title: 'Clergy & Couples Retreat',
      date: 'May 1-3, 2025',
      time: '6:00 AM - 12:00 PM',
      location: 'Global (Online)',
      category: 'retreat',
      description: 'A time of rest, refreshing, and bonding for church leaders and their spouses.',
      image: 'https://readdy.ai/api/search-image?query=global%20online%20prayer%20meeting%20with%20people%20from%20different%20nations%20praying%20together%20via%20video%20conference%2C%20international%20christian%20unity%2C%20diverse%20believers%20in%20worship%2C%20spiritual%20gathering&width=600&height=400&seq=prayersummit&orientation=landscape',
      featured: false,
      registrationLink: ''
    },
    {
      id: 8,
      title: 'Youths Alive Congress',
      date: 'May 1-3, 2025',
      time: '6:00 AM - 12:00 PM',
      location: 'Global (Online)',
      category: 'congress',
      description: 'An empowering assembly aimed at inspiring and directing the next generation.',
      image: 'https://readdy.ai/api/search-image?query=global%20online%20prayer%20meeting%20with%20people%20from%20different%20nations%20praying%20together%20via%20video%20conference%2C%20international%20christian%20unity%2C%20diverse%20believers%20in%20worship%2C%20spiritual%20gathering&width=600&height=400&seq=prayersummit&orientation=landscape',
      featured: false,
      registrationLink: ''
    }
  ];

  const categories = [
    { id: 'all', name: 'All Events', count: upcomingEvents.length },
    { id: 'convention', name: 'Conventions', count: upcomingEvents.filter(e => e.category === 'convention').length },
    { id: 'service', name: 'Service', count: upcomingEvents.filter(e => e.category === 'service').length },
    { id: 'congress', name: 'Congress', count: upcomingEvents.filter(e => e.category === 'congress').length },
    { id: 'training', name: 'Training', count: upcomingEvents.filter(e => e.category === 'training').length },
    { id: 'retreat', name: 'Retreat', count: upcomingEvents.filter(e => e.category === 'retreat').length },
    { id: 'prayer', name: 'Prayer', count: upcomingEvents.filter(e => e.category === 'prayer').length }
  ];

  const filteredEvents = selectedCategory === 'all' 
    ? upcomingEvents 
    : upcomingEvents.filter(event => event.category === selectedCategory);

  const featuredEvent = upcomingEvents.find(event => event.featured);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="absolute inset-0 bg-black/50"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=large%20christian%20gathering%20with%20thousands%20of%20people%20in%20worship%2C%20apostolic%20conference%20atmosphere%2C%20diverse%20international%20crowd%2C%20powerful%20ministry%20event%2C%20inspiring%20spiritual%20gathering&width=1200&height=600&seq=eventshero&orientation=landscape')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Upcoming Events
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Join us for life-changing gatherings, apostolic training, and global ministry events that are transforming nations
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://portal.paamintl.org/" 
              className="bg-[#b8144a] hover:bg-[#9a1139] text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              View All Events
            </a>
            <a 
              href="/live-streaming" 
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Watch Live
            </a>
          </div>
        </div>
      </section>

      {/* Featured Event */}
      {featuredEvent && (
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Featured Event</h2>
              <p className="text-xl text-gray-600">Don't miss our flagship gathering</p>
            </div>
            
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className="md:flex">
                <div className="md:w-1/2">
                  <img 
                    src={featuredEvent.image} 
                    alt={featuredEvent.title}
                    className="w-full h-64 md:h-full object-cover object-top"
                  />
                </div>
                <div className="md:w-1/2 p-8 md:p-12">
                  <div className="flex items-center mb-4">
                    <span className="bg-[#b8144a] text-white px-3 py-1 rounded-full text-sm font-semibold uppercase">
                      Featured
                    </span>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{featuredEvent.title}</h3>
                  <p className="text-gray-600 mb-6">{featuredEvent.description}</p>
                  
                  <div className="space-y-3 mb-8">
                    <div className="flex items-center text-gray-700">
                      <i className="ri-calendar-line w-5 h-5 flex items-center justify-center mr-3 text-[#b8144a]"></i>
                      <span>{featuredEvent.date}</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                      <i className="ri-time-line w-5 h-5 flex items-center justify-center mr-3 text-[#b8144a]"></i>
                      <span>{featuredEvent.time}</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                      <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mr-3 text-[#b8144a]"></i>
                      <span>{featuredEvent.location}</span>
                    </div>
                  </div>
                  
                  <a 
                    href={featuredEvent.registrationLink}
                    className="bg-[#b8144a] hover:bg-[#9a1139] text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap inline-block"
                  >
                    Register Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Event Categories */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Browse Events by Category</h2>
            <p className="text-xl text-gray-600">Find the perfect event for your spiritual journey</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-[#b8144a] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>

          {/* Events Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredEvents.map((event) => (
              <div key={event.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={event.image} 
                  alt={event.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold uppercase ${
                      event.category === 'convention' ? 'bg-purple-100 text-purple-800' :
                      event.category === 'crusade' ? 'bg-red-100 text-red-800' :
                      event.category === 'rally' ? 'bg-blue-100 text-blue-800' :
                      event.category === 'training' ? 'bg-green-100 text-green-800' :
                      event.category === 'mission' ? 'bg-orange-100 text-orange-800' :
                      'bg-indigo-100 text-indigo-800'
                    }`}>
                      {event.category}
                    </span>
                    {event.featured && (
                      <span className="bg-[#b8144a] text-white px-2 py-1 rounded text-xs font-semibold">
                        Featured
                      </span>
                    )}
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{event.title}</h3>
                  <p className="text-gray-600 mb-4 text-sm">{event.description}</p>
                  
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center text-sm text-gray-700">
                      {/* <i className="ri-calendar-line w-4 h-4 flex items-center justify-center mr-2 text-[#b8144a]"></i>
                      <span>{event.date}</span> */}
                    </div>
                    <div className="flex items-center text-sm text-gray-700">
                      {/* <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center mr-2 text-[#b8144a]"></i>
                      <span>{event.location}</span> */}
                    </div>
                  </div>
                  
                  {/* <a 
                    href={event.registrationLink}
                    className="w-full bg-[#b8144a] hover:bg-[#9a1139] text-white py-2 px-4 rounded-lg font-semibold transition-colors text-center block whitespace-nowrap"
                  >
                    Learn More
                  </a> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-[#b8144a] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Stay Connected</h2>
          <p className="text-xl mb-8">
            Never miss an event! Subscribe to our newsletter and follow us on social media for the latest updates on upcoming gatherings, training sessions, and ministry events.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://portal.paamintl.org/" 
              className="bg-white text-[#b8144a] hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Subscribe to Newsletter
            </a>
            <a 
              href="/live-streaming" 
              className="border-2 border-white text-white hover:bg-white hover:text-[#b8144a] px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Watch Live Events
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventsPage;
